import { CEFR_LEVELS } from '../cefr';

export const CEFR_EQUIVALENCES = {
  [CEFR_LEVELS[0]]: { ielts: 'below 4.0', toefl: 'below 32' },
  [CEFR_LEVELS[1]]: { ielts: '4.0', toefl: '32-41' },
  [CEFR_LEVELS[2]]: { ielts: '4.5-5.5', toefl: '42-71' },
  [CEFR_LEVELS[3]]: { ielts: '5.5-6.5', toefl: '72-94' },
  [CEFR_LEVELS[4]]: { ielts: '7.0-8.0', toefl: '95-113' },
  [CEFR_LEVELS[5]]: { ielts: '8.5-9.0', toefl: '114-120' },
} as const;
